var exports = {
  "A": "xa15a2ab7--991a1f--item",
};

module.exports = exports;
